import { bool, func, string } from 'prop-types';
import * as styles from './SubscriptionCancelled.module.scss';

const options = { year: 'numeric', month: 'long', day: 'numeric' };

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', options);
};

const SubscriptionCancelled = ({
  onReturn,
  isMobile = false,
  isLastRefillProduct,
  nextRenewalDate,
  isRefillProduct,
  isRefillOnly,
}) => {
  const backButtonText = isMobile ? 'Back To My Subscriptions' : 'Return To My Subscriptions';

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Your Subscription Has Been Cancelled</h1>
      <p className={styles.info}>
        All future deliveries have been cancelled. You will not be charged for any future
        deliveries.
        {isLastRefillProduct && nextRenewalDate && isRefillProduct && isRefillOnly && (
          <span className={styles.endDateDisclaimer}>
            You will lose access to your membership on {formatDate(nextRenewalDate)}.
          </span>
        )}
      </p>
      <button type="button" className={styles.button} onClick={onReturn}>
        {backButtonText}
      </button>
    </div>
  );
};

SubscriptionCancelled.propTypes = {
  onReturn: func.isRequired,
  isMobile: bool,
  isLastRefillProduct: bool.isRequired,
  nextRenewalDate: string,
  isRefillProduct: bool,
  isRefillOnly: bool.isRequired,
};

export default SubscriptionCancelled;
